import { type HTMLAttributes, type ReactNode } from "react";
import { cn } from "./utils/cn";

export type StackGap = "sm" | "md" | "lg" | "xl" | "2xl";
export type StackAlignItems = "start" | "stretch" | "center" | "end";

export interface StackProps extends HTMLAttributes<HTMLDivElement> {
  gap?: StackGap;
  /** Cross-axis alignment of children. Defaults to "start" so inline elements
      (Pill, Button) hug their content rather than stretching. */
  alignItems?: StackAlignItems;
  children?: ReactNode;
}

export const Stack = ({
  gap = "md",
  alignItems = "start",
  className,
  children,
  ...rest
}: StackProps) => (
  <div
    className={cn(
      "hui-stack",
      `hui-stack--gap-${gap}`,
      alignItems !== "start" && `hui-stack--items-${alignItems}`,
      className
    )}
    {...rest}
  >
    {children}
  </div>
);
